/* tslint:disable */
/* eslint-disable */
/**
 * Poshwatch API
 * Poshwatch API provides analytics and insights for Poshmark sellers.  This API enables sellers to analyze their closets, get listing recommendations, and access detailed performance metrics to optimize their Poshmark business.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AnalyzeSingleListingRequestRegionEnum = {
    Us: 'us',
    Ca: 'ca'
};
export const ClosetMetricsSubscriptionTypeEnum = {
    TrialMobile: 'trial_mobile',
    TrialWeb: 'trial_web',
    SubscribedMobile: 'subscribed_mobile',
    SubscribedWeb: 'subscribed_web',
    NonSubscribed: 'non_subscribed'
};
export const ClosetSummaryResponseAnalysisStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed'
};
export const GetAvailableImageModels200ResponseModelsValueAdditionalPropertiesValueModelEnum = {
    None: 'none',
    NoFace: 'no_face',
    Face: 'face'
};
/**
 * Types of issues that can be identified in a listing
 * @export
 * @enum {string}
 */
export const IssueType = {
    Freshness: 'freshness',
    Title: 'title',
    Description: 'description',
    Color: 'color',
    Condition: 'condition',
    BrandTag: 'brandTag',
    StyleTags: 'styleTags'
};
export const StatInsightLevelEnum = {
    Success: 'success',
    Warning: 'warning',
    Danger: 'danger'
};
/**
 * The subscription type of the user
 * @export
 * @enum {string}
 */
export const SubscriptionType = {
    TrialMobile: 'trial_mobile',
    TrialWeb: 'trial_web',
    SubscribedMobile: 'subscribed_mobile',
    SubscribedWeb: 'subscribed_web',
    NonSubscribed: 'non_subscribed'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Analyzes a specific listing from a user\'s closet and returns detailed analysis results
         * @summary Analyze a single listing
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username/closet ID
         * @param {string} listingId The listing ID to analyze
         * @param {AnalyzeSingleListingRequest} [analyzeSingleListingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeSingleListing: (userId, closetId, listingId, analyzeSingleListingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('analyzeSingleListing', 'userId', userId);
            // verify required parameter 'closetId' is not null or undefined
            assertParamExists('analyzeSingleListing', 'closetId', closetId);
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('analyzeSingleListing', 'listingId', listingId);
            const localVarPath = `/api/v2/closet/{userId}/{closetId}/listing/{listingId}/analyze`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"closetId"}}`, encodeURIComponent(String(closetId)))
                .replace(`{${"listingId"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyzeSingleListingRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Applies a discount to a subscription from the cancellation flow
         * @summary Apply a discount to a subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDiscount: (applyDiscountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applyDiscountRequest' is not null or undefined
            assertParamExists('applyDiscount', 'applyDiscountRequest', applyDiscountRequest);
            const localVarPath = `/api/v2/cancellation-flow/apply-discount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(applyDiscountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cancels users stripe subscription from the cancellation flow
         * @summary Cancels users stripe subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: (applyDiscountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applyDiscountRequest' is not null or undefined
            assertParamExists('cancelSubscription', 'applyDiscountRequest', applyDiscountRequest);
            const localVarPath = `/api/v2/cancellation-flow/cancel-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(applyDiscountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if the authenticated user has admin privileges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdminStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/cloud-share/admin/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generates a product photo by applying a model\'s outfit to an input image.
         * @summary Generate a product photo
         * @param {GenerateProductPhotoRequest | null} generateProductPhotoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductPhoto: (generateProductPhotoRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateProductPhotoRequest' is not null or undefined
            assertParamExists('generateProductPhoto', 'generateProductPhotoRequest', generateProductPhotoRequest);
            const localVarPath = `/api/v2/image-gen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateProductPhotoRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a map of model categories and their associated styles, photos, and metadata. Each category contains styles, and each style has a cover photo and a collection of photos organized by camera angle.
         * @summary Get available image generation models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableImageModels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/image-gen/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve paginated analysis results filtered by issue type or rating range
         * @summary Get paginated closet analysis
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username
         * @param {GetClosetAnalysisFilterTypeEnum} [filterType] Type of filter to apply
         * @param {GetClosetAnalysisIssueTypeEnum} [issueType] Filter by issue type (required when filterType is \&#39;issue\&#39;)
         * @param {GetClosetAnalysisRatingRangeEnum} [ratingRange] Filter by rating range (required when filterType is \&#39;rating\&#39;)
         * @param {number} [limit] Items per page
         * @param {string} [nextPageToken] Token for fetching the next page of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetAnalysis: (userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getClosetAnalysis', 'userId', userId);
            // verify required parameter 'closetId' is not null or undefined
            assertParamExists('getClosetAnalysis', 'closetId', closetId);
            const localVarPath = `/api/v2/closet-report/{userId}/{closetId}/analysis`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"closetId"}}`, encodeURIComponent(String(closetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }
            if (issueType !== undefined) {
                localVarQueryParameter['issueType'] = issueType;
            }
            if (ratingRange !== undefined) {
                localVarQueryParameter['ratingRange'] = ratingRange;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get metrics for all closets with active schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetMetrics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/cloud-share/admin/get-closet-metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve the latest summary for a closet
         * @summary Get closet report summary
         * @param {string} userId The user ID requesting the summary
         * @param {string} closetId The Poshmark username
         * @param {GetClosetSummaryRegionEnum} region The Poshmark region (ca or us)
         * @param {boolean} [forceRerun] Force rerun of analysis regardless of existing summary age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetSummary: (userId, closetId, region, forceRerun, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getClosetSummary', 'userId', userId);
            // verify required parameter 'closetId' is not null or undefined
            assertParamExists('getClosetSummary', 'closetId', closetId);
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getClosetSummary', 'region', region);
            const localVarPath = `/api/v2/closet-report/{userId}/{closetId}/summary`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"closetId"}}`, encodeURIComponent(String(closetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (forceRerun !== undefined) {
                localVarQueryParameter['forceRerun'] = forceRerun;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve Poshmark user data for a closet
         * @summary Get closet user information
         * @param {string} userId The user ID requesting the info
         * @param {string} closetId The Poshmark username
         * @param {GetClosetUserRegionEnum} [region] The Poshmark region (ca or us)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetUser: (userId, closetId, region, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getClosetUser', 'userId', userId);
            // verify required parameter 'closetId' is not null or undefined
            assertParamExists('getClosetUser', 'closetId', closetId);
            const localVarPath = `/api/v2/closet/{userId}/{closetId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"closetId"}}`, encodeURIComponent(String(closetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get closet names for enabled schedules grouped by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulesByHour: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/cloud-share/admin/schedules-by-hour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the status of a subscription
         * @summary Gets the status of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/settings/get-subscription-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Analyzes sell-through rates for styles within a specific brand to identify trending items. Returns styles sorted by sell-through rate, with low-volume items deprioritized. Uses cursor-based pagination for efficient handling of large result sets.
         * @summary Get trending styles for a brand
         * @param {Array<string>} [brands] Array of brands to analyze. If not provided, returns all brands.
         * @param {number} [limit] Number of items per page (max 100)
         * @param {string} [cursor] Cursor for pagination. Use the nextCursor from the previous response to get the next page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendingStyles: (brands, limit, cursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/trending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (brands) {
                localVarQueryParameter['brands'] = brands;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve closet information for a specific Poshmark username
         * @summary Get user information by username
         * @param {string} username The Poshmark username to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoByUsername: (username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserInfoByUsername', 'username', username);
            const localVarPath = `/api/v2/cloud-share/admin/user-info/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve logs for a specific user
         * @summary Get user logs
         * @param {string} userId The user ID to retrieve logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLogs: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserLogs', 'userId', userId);
            const localVarPath = `/api/v2/cloud-share/user/{userId}/logs`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the count of unique users who have enabled offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersWithOffersCount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/cloud-share/admin/users-with-offers/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for available and sold products on Poshmark with filtering and analysis
         * @summary Search for products on Poshmark
         * @param {string} query Search query string
         * @param {number} [depth] Number of pages to search (max 4)
         * @param {boolean} [checkLimits] Whether to check and enforce user limits
         * @param {boolean} [tokenize] Whether to tokenize the search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearch: (query, depth, checkLimits, tokenize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('productSearch', 'query', query);
            const localVarPath = `/api/v2/product-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }
            if (checkLimits !== undefined) {
                localVarQueryParameter['checkLimits'] = checkLimits;
            }
            if (tokenize !== undefined) {
                localVarQueryParameter['tokenize'] = tokenize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Reenables a subscription from the cancellation flow
         * @summary Reenables a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reenableSubscription: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/cancellation-flow/reenable-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         * Analyzes a specific listing from a user\'s closet and returns detailed analysis results
         * @summary Analyze a single listing
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username/closet ID
         * @param {string} listingId The listing ID to analyze
         * @param {AnalyzeSingleListingRequest} [analyzeSingleListingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.analyzeSingleListing']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Applies a discount to a subscription from the cancellation flow
         * @summary Apply a discount to a subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDiscount(applyDiscountRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applyDiscount(applyDiscountRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.applyDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Cancels users stripe subscription from the cancellation flow
         * @summary Cancels users stripe subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(applyDiscountRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelSubscription(applyDiscountRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.cancelSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check if the authenticated user has admin privileges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdminStatus(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkAdminStatus(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.checkAdminStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Generates a product photo by applying a model\'s outfit to an input image.
         * @summary Generate a product photo
         * @param {GenerateProductPhotoRequest | null} generateProductPhotoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductPhoto(generateProductPhotoRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateProductPhoto(generateProductPhotoRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.generateProductPhoto']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a map of model categories and their associated styles, photos, and metadata. Each category contains styles, and each style has a cover photo and a collection of photos organized by camera angle.
         * @summary Get available image generation models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableImageModels(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableImageModels(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getAvailableImageModels']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve paginated analysis results filtered by issue type or rating range
         * @summary Get paginated closet analysis
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username
         * @param {GetClosetAnalysisFilterTypeEnum} [filterType] Type of filter to apply
         * @param {GetClosetAnalysisIssueTypeEnum} [issueType] Filter by issue type (required when filterType is \&#39;issue\&#39;)
         * @param {GetClosetAnalysisRatingRangeEnum} [ratingRange] Filter by rating range (required when filterType is \&#39;rating\&#39;)
         * @param {number} [limit] Items per page
         * @param {string} [nextPageToken] Token for fetching the next page of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getClosetAnalysis']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get metrics for all closets with active schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetMetrics(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClosetMetrics(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getClosetMetrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve the latest summary for a closet
         * @summary Get closet report summary
         * @param {string} userId The user ID requesting the summary
         * @param {string} closetId The Poshmark username
         * @param {GetClosetSummaryRegionEnum} region The Poshmark region (ca or us)
         * @param {boolean} [forceRerun] Force rerun of analysis regardless of existing summary age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetSummary(userId, closetId, region, forceRerun, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClosetSummary(userId, closetId, region, forceRerun, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getClosetSummary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve Poshmark user data for a closet
         * @summary Get closet user information
         * @param {string} userId The user ID requesting the info
         * @param {string} closetId The Poshmark username
         * @param {GetClosetUserRegionEnum} [region] The Poshmark region (ca or us)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetUser(userId, closetId, region, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClosetUser(userId, closetId, region, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getClosetUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get closet names for enabled schedules grouped by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulesByHour(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulesByHour(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulesByHour']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the status of a subscription
         * @summary Gets the status of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionStatus(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionStatus(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSubscriptionStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Analyzes sell-through rates for styles within a specific brand to identify trending items. Returns styles sorted by sell-through rate, with low-volume items deprioritized. Uses cursor-based pagination for efficient handling of large result sets.
         * @summary Get trending styles for a brand
         * @param {Array<string>} [brands] Array of brands to analyze. If not provided, returns all brands.
         * @param {number} [limit] Number of items per page (max 100)
         * @param {string} [cursor] Cursor for pagination. Use the nextCursor from the previous response to get the next page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendingStyles(brands, limit, cursor, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTrendingStyles(brands, limit, cursor, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getTrendingStyles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve closet information for a specific Poshmark username
         * @summary Get user information by username
         * @param {string} username The Poshmark username to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoByUsername(username, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserInfoByUsername(username, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getUserInfoByUsername']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve logs for a specific user
         * @summary Get user logs
         * @param {string} userId The user ID to retrieve logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLogs(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserLogs(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getUserLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the count of unique users who have enabled offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersWithOffersCount(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersWithOffersCount(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getUsersWithOffersCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for available and sold products on Poshmark with filtering and analysis
         * @summary Search for products on Poshmark
         * @param {string} query Search query string
         * @param {number} [depth] Number of pages to search (max 4)
         * @param {boolean} [checkLimits] Whether to check and enforce user limits
         * @param {boolean} [tokenize] Whether to tokenize the search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearch(query, depth, checkLimits, tokenize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productSearch(query, depth, checkLimits, tokenize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.productSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Reenables a subscription from the cancellation flow
         * @summary Reenables a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reenableSubscription(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reenableSubscription(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.reenableSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         * Analyzes a specific listing from a user\'s closet and returns detailed analysis results
         * @summary Analyze a single listing
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username/closet ID
         * @param {string} listingId The listing ID to analyze
         * @param {AnalyzeSingleListingRequest} [analyzeSingleListingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options) {
            return localVarFp.analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a discount to a subscription from the cancellation flow
         * @summary Apply a discount to a subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDiscount(applyDiscountRequest, options) {
            return localVarFp.applyDiscount(applyDiscountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels users stripe subscription from the cancellation flow
         * @summary Cancels users stripe subscription
         * @param {ApplyDiscountRequest} applyDiscountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(applyDiscountRequest, options) {
            return localVarFp.cancelSubscription(applyDiscountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if the authenticated user has admin privileges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdminStatus(options) {
            return localVarFp.checkAdminStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a product photo by applying a model\'s outfit to an input image.
         * @summary Generate a product photo
         * @param {GenerateProductPhotoRequest | null} generateProductPhotoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProductPhoto(generateProductPhotoRequest, options) {
            return localVarFp.generateProductPhoto(generateProductPhotoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a map of model categories and their associated styles, photos, and metadata. Each category contains styles, and each style has a cover photo and a collection of photos organized by camera angle.
         * @summary Get available image generation models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableImageModels(options) {
            return localVarFp.getAvailableImageModels(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated analysis results filtered by issue type or rating range
         * @summary Get paginated closet analysis
         * @param {string} userId The user ID requesting the analysis
         * @param {string} closetId The Poshmark username
         * @param {GetClosetAnalysisFilterTypeEnum} [filterType] Type of filter to apply
         * @param {GetClosetAnalysisIssueTypeEnum} [issueType] Filter by issue type (required when filterType is \&#39;issue\&#39;)
         * @param {GetClosetAnalysisRatingRangeEnum} [ratingRange] Filter by rating range (required when filterType is \&#39;rating\&#39;)
         * @param {number} [limit] Items per page
         * @param {string} [nextPageToken] Token for fetching the next page of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options) {
            return localVarFp.getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get metrics for all closets with active schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetMetrics(options) {
            return localVarFp.getClosetMetrics(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the latest summary for a closet
         * @summary Get closet report summary
         * @param {string} userId The user ID requesting the summary
         * @param {string} closetId The Poshmark username
         * @param {GetClosetSummaryRegionEnum} region The Poshmark region (ca or us)
         * @param {boolean} [forceRerun] Force rerun of analysis regardless of existing summary age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetSummary(userId, closetId, region, forceRerun, options) {
            return localVarFp.getClosetSummary(userId, closetId, region, forceRerun, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Poshmark user data for a closet
         * @summary Get closet user information
         * @param {string} userId The user ID requesting the info
         * @param {string} closetId The Poshmark username
         * @param {GetClosetUserRegionEnum} [region] The Poshmark region (ca or us)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosetUser(userId, closetId, region, options) {
            return localVarFp.getClosetUser(userId, closetId, region, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get closet names for enabled schedules grouped by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulesByHour(options) {
            return localVarFp.getSchedulesByHour(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the status of a subscription
         * @summary Gets the status of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionStatus(options) {
            return localVarFp.getSubscriptionStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Analyzes sell-through rates for styles within a specific brand to identify trending items. Returns styles sorted by sell-through rate, with low-volume items deprioritized. Uses cursor-based pagination for efficient handling of large result sets.
         * @summary Get trending styles for a brand
         * @param {Array<string>} [brands] Array of brands to analyze. If not provided, returns all brands.
         * @param {number} [limit] Number of items per page (max 100)
         * @param {string} [cursor] Cursor for pagination. Use the nextCursor from the previous response to get the next page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendingStyles(brands, limit, cursor, options) {
            return localVarFp.getTrendingStyles(brands, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve closet information for a specific Poshmark username
         * @summary Get user information by username
         * @param {string} username The Poshmark username to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoByUsername(username, options) {
            return localVarFp.getUserInfoByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve logs for a specific user
         * @summary Get user logs
         * @param {string} userId The user ID to retrieve logs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLogs(userId, options) {
            return localVarFp.getUserLogs(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the count of unique users who have enabled offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersWithOffersCount(options) {
            return localVarFp.getUsersWithOffersCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Search for available and sold products on Poshmark with filtering and analysis
         * @summary Search for products on Poshmark
         * @param {string} query Search query string
         * @param {number} [depth] Number of pages to search (max 4)
         * @param {boolean} [checkLimits] Whether to check and enforce user limits
         * @param {boolean} [tokenize] Whether to tokenize the search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSearch(query, depth, checkLimits, tokenize, options) {
            return localVarFp.productSearch(query, depth, checkLimits, tokenize, options).then((request) => request(axios, basePath));
        },
        /**
         * Reenables a subscription from the cancellation flow
         * @summary Reenables a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reenableSubscription(options) {
            return localVarFp.reenableSubscription(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Analyzes a specific listing from a user\'s closet and returns detailed analysis results
     * @summary Analyze a single listing
     * @param {string} userId The user ID requesting the analysis
     * @param {string} closetId The Poshmark username/closet ID
     * @param {string} listingId The listing ID to analyze
     * @param {AnalyzeSingleListingRequest} [analyzeSingleListingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options) {
        return DefaultApiFp(this.configuration).analyzeSingleListing(userId, closetId, listingId, analyzeSingleListingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Applies a discount to a subscription from the cancellation flow
     * @summary Apply a discount to a subscription
     * @param {ApplyDiscountRequest} applyDiscountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    applyDiscount(applyDiscountRequest, options) {
        return DefaultApiFp(this.configuration).applyDiscount(applyDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancels users stripe subscription from the cancellation flow
     * @summary Cancels users stripe subscription
     * @param {ApplyDiscountRequest} applyDiscountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelSubscription(applyDiscountRequest, options) {
        return DefaultApiFp(this.configuration).cancelSubscription(applyDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if the authenticated user has admin privileges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checkAdminStatus(options) {
        return DefaultApiFp(this.configuration).checkAdminStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generates a product photo by applying a model\'s outfit to an input image.
     * @summary Generate a product photo
     * @param {GenerateProductPhotoRequest | null} generateProductPhotoRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateProductPhoto(generateProductPhotoRequest, options) {
        return DefaultApiFp(this.configuration).generateProductPhoto(generateProductPhotoRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a map of model categories and their associated styles, photos, and metadata. Each category contains styles, and each style has a cover photo and a collection of photos organized by camera angle.
     * @summary Get available image generation models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAvailableImageModels(options) {
        return DefaultApiFp(this.configuration).getAvailableImageModels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve paginated analysis results filtered by issue type or rating range
     * @summary Get paginated closet analysis
     * @param {string} userId The user ID requesting the analysis
     * @param {string} closetId The Poshmark username
     * @param {GetClosetAnalysisFilterTypeEnum} [filterType] Type of filter to apply
     * @param {GetClosetAnalysisIssueTypeEnum} [issueType] Filter by issue type (required when filterType is \&#39;issue\&#39;)
     * @param {GetClosetAnalysisRatingRangeEnum} [ratingRange] Filter by rating range (required when filterType is \&#39;rating\&#39;)
     * @param {number} [limit] Items per page
     * @param {string} [nextPageToken] Token for fetching the next page of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options) {
        return DefaultApiFp(this.configuration).getClosetAnalysis(userId, closetId, filterType, issueType, ratingRange, limit, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get metrics for all closets with active schedules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getClosetMetrics(options) {
        return DefaultApiFp(this.configuration).getClosetMetrics(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve the latest summary for a closet
     * @summary Get closet report summary
     * @param {string} userId The user ID requesting the summary
     * @param {string} closetId The Poshmark username
     * @param {GetClosetSummaryRegionEnum} region The Poshmark region (ca or us)
     * @param {boolean} [forceRerun] Force rerun of analysis regardless of existing summary age
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getClosetSummary(userId, closetId, region, forceRerun, options) {
        return DefaultApiFp(this.configuration).getClosetSummary(userId, closetId, region, forceRerun, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve Poshmark user data for a closet
     * @summary Get closet user information
     * @param {string} userId The user ID requesting the info
     * @param {string} closetId The Poshmark username
     * @param {GetClosetUserRegionEnum} [region] The Poshmark region (ca or us)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getClosetUser(userId, closetId, region, options) {
        return DefaultApiFp(this.configuration).getClosetUser(userId, closetId, region, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get closet names for enabled schedules grouped by hour
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulesByHour(options) {
        return DefaultApiFp(this.configuration).getSchedulesByHour(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the status of a subscription
     * @summary Gets the status of a subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSubscriptionStatus(options) {
        return DefaultApiFp(this.configuration).getSubscriptionStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Analyzes sell-through rates for styles within a specific brand to identify trending items. Returns styles sorted by sell-through rate, with low-volume items deprioritized. Uses cursor-based pagination for efficient handling of large result sets.
     * @summary Get trending styles for a brand
     * @param {Array<string>} [brands] Array of brands to analyze. If not provided, returns all brands.
     * @param {number} [limit] Number of items per page (max 100)
     * @param {string} [cursor] Cursor for pagination. Use the nextCursor from the previous response to get the next page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTrendingStyles(brands, limit, cursor, options) {
        return DefaultApiFp(this.configuration).getTrendingStyles(brands, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve closet information for a specific Poshmark username
     * @summary Get user information by username
     * @param {string} username The Poshmark username to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserInfoByUsername(username, options) {
        return DefaultApiFp(this.configuration).getUserInfoByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve logs for a specific user
     * @summary Get user logs
     * @param {string} userId The user ID to retrieve logs for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserLogs(userId, options) {
        return DefaultApiFp(this.configuration).getUserLogs(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the count of unique users who have enabled offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUsersWithOffersCount(options) {
        return DefaultApiFp(this.configuration).getUsersWithOffersCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for available and sold products on Poshmark with filtering and analysis
     * @summary Search for products on Poshmark
     * @param {string} query Search query string
     * @param {number} [depth] Number of pages to search (max 4)
     * @param {boolean} [checkLimits] Whether to check and enforce user limits
     * @param {boolean} [tokenize] Whether to tokenize the search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    productSearch(query, depth, checkLimits, tokenize, options) {
        return DefaultApiFp(this.configuration).productSearch(query, depth, checkLimits, tokenize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reenables a subscription from the cancellation flow
     * @summary Reenables a subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reenableSubscription(options) {
        return DefaultApiFp(this.configuration).reenableSubscription(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const GetClosetAnalysisFilterTypeEnum = {
    Issue: 'issue',
    Rating: 'rating'
};
/**
 * @export
 */
export const GetClosetAnalysisIssueTypeEnum = {
    Freshness: 'freshness',
    Shares: 'shares',
    Quality: 'quality'
};
/**
 * @export
 */
export const GetClosetAnalysisRatingRangeEnum = {
    NeedsImprovement: 'needs_improvement',
    Good: 'good',
    Excellent: 'excellent'
};
/**
 * @export
 */
export const GetClosetSummaryRegionEnum = {
    Ca: 'ca',
    Us: 'us'
};
/**
 * @export
 */
export const GetClosetUserRegionEnum = {
    Ca: 'ca',
    Us: 'us'
};
